// import { Checkbox } from "antd";
// import { Fragment, useEffect, useMemo, useRef, useState } from "react";
// import {
//   useAsyncDebounce,
//   useBlockLayout,
//   useColumnOrder,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import { useSticky } from "react-table-sticky";
// import { toast, ToastContainer } from "react-toastify";
// // import CheckBox from "./ReactTableFiles/CheckBox";
// // import ColumnFilter from "./ReactTableFiles/ColumnFilter";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import { TextField, Tooltip, InputAdornment } from "@mui/material";
// import { common_axios } from "../../../../App";
// import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
// import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
// import Backdrop from "@mui/material/Backdrop";
// import Loader from "../../../../components/Loader";
// import TableViewIcon from "@mui/icons-material/TableView";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axios from "axios";
// import { dateFormatter } from "../../../../helper/helper";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { Link } from "react-router-dom";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StopCircleIcon from "@mui/icons-material/StopCircle";
// import PauseCircleIcon from "@mui/icons-material/PauseCircle";
// import Swal from "sweetalert2";

// import {
//   actionid,
//   runningState,
//   pauseState,
//   resumeState,
//   refreshrunning,
//   schedulelist,
//   runninglist,
//   stoppedlist,
//   mainSkelton,
// } from "../../../../redux/features/pageSlices";
// import { useDispatch } from "react-redux";
// import NotStartedIcon from "@mui/icons-material/NotStarted";
// import Box from "@mui/material/Box";
// import Skeleton from "@mui/material/Skeleton";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import { processlist } from "../../../../redux/features/pageSlices";
// import InfoIcon from "@mui/icons-material/Info";
// import * as React from "react";
// import Pagination from "@mui/material/Pagination";
// import {
//   Stack,
// } from "@mui/material";
// export default function RunningAdmin({ runningArray, open: open1 }) {
//   // .....................................................Scroll Bar.................................................................//
//   const wrapper1Ref = useRef(null);
//   const wrapper2Ref = useRef(null);
//   const div1Ref = useRef(null);
//   const div2Ref = useRef(null);

//   const handleWrapper1Scroll = (e) => {
//     wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
//   };

//   const handleWrapper2Scroll = (e) => {
//     wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
//   };

//   const updateDivWidths = () => {
//     // if (div1Ref.current && div2Ref.current) {
//     //   div1Ref.current.style.width =
//     //     div2Ref.current.querySelector("table").offsetWidth + "px";
//     //   div2Ref.current.style.width =
//     //     div2Ref.current.querySelector("table").offsetWidth + "px";
//     // }
//   };

//   // ..................................................End Of Scroll Bar..............................................................//

//   const dispatch = useDispatch();
//   const [open, setOpen] = useState();
//   const [scheduledata, setScheduleData] = useState([]);
//   const [ruuningFun, setRunningFun] = useState(true);
//   const [runningStateFun, setrunningStateFun] = useState();
//   const [ScheduleTotalCount, setScheduleTotalCount] = useState();
//   const [data, setData] = useState([]);
//   const [resumeButton, setResumeButton] = useState(undefined);
//   const [pauseButton, setpauseButton] = useState(undefined);
//   const [hideSkeleton, sethideSkeleton] = useState();
//   const [data1, setData1] = useState([]);
//   const [paginationPage, setPaginationPage] = React.useState(1);
//   const [TableStatus, setTableStatus] = useState({
//     pageNo: 0,
//     pageSize: 10,
//   });
//   const [stopButton, setStopButton] = useState(undefined);
//   const resumebuttonModal = useRef(null);

//   const resumeModal = async (cell) => {
//     await setResumeButton(cell.row.original);
//     await resumebuttonModal.current.click();
//   };
//   const pausebuttonModal = useRef(null);

//   const pauseModal = async (cell) => {
//     await setpauseButton(cell.row.original);
//     await pausebuttonModal.current.click();
//   };
//   const stopbuttonModal = useRef(null);

//   const stopModal = async (cell) => {
//     await setStopButton(cell.row.original);
//     await stopbuttonModal.current.click();
//   };
//   const customId1 = "custom-id-yess";

//   const defaultColumn = useMemo(() => {
//     return {
//       Filter: ColumnFilter,
//     };
//   }, []);

//   // ...........................Rfresh API....................//
//   async function RefreshBtn(values) {
//     // setTableLoader(true);

//     sethideSkeleton(true);
//     dispatch(mainSkelton(true));
//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
//         {
//           pageNo: TableStatus?.pageNo,
//           pageSize: TableStatus?.pageSize,
//         }
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         sethideSkeleton(false);
//         // setData(result.data.runningList.content);
//         // await setTotalPage(result.data.scheduledList.totalPages);
//         // await settotalPageCount(result.data.scheduledList.pageable.pageNumber);
//         // await setScheduleTotalCount(result.data.scheduledList.totalElements);
//         await setData1(result.data?.running);
//         for (
//           let index = 0;
//           index < result.data.running?.length;
//           index++
//         ) {
//           result.data.running[index][`Show`] = true;
//           // arr.push(obj);
//         }
//         // dispatch(refreshrunning(result.data));
//         dispatch(mainSkelton(false));
//         dispatch(schedulelist(result?.data?.scheduled));
//         dispatch(runninglist(result?.data?.running));
//         dispatch(stoppedlist(result?.data.stopped));
//         dispatch(processlist(result?.data?.createdCampaign));

//         // dispatch(processlist(result?.data.process));
//         // await toast.success("success", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else if (result.data.statusDescription.statusCode == 202) {
//         sethideSkeleton(false);

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         sethideSkeleton(false);
//         dispatch(mainSkelton(false));
//         // toast.error(result.data.statusDescription.statusMessage,{
//         //   toastId: customId1,
//         //   theme: "colored",
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       sethideSkeleton(false);
//       dispatch(mainSkelton(false));

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }
//   // ...........................Status API....................//
//   async function RunningPost(values) {
//     // setTableLoader(true);

//     setOpen(true);
//     setData([]);
//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
//         {
//           pageNo: TableStatus?.pageNo,
//           pageSize: TableStatus?.pageSize,
//         }
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         await setData1(result.data?.running);

//         setData(result.data.running.content);

//         for (
//           let index = 0;
//           index < result.data.running?.content?.length;
//           index++
//         ) {
//           result.data.running.content[index][`Show`] = true;
//           // arr.push(obj);
//         }

//         // await setData1(result.data?.running);

//         // await setTotalPage(result.data.runningList.totalPages);
//         // await settotalPageCount(result.data.runningList.pageable.pageNumber);
//         await setScheduleTotalCount(result.data.running.totalElements);
//         // await toast.success("success", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else {
//         setOpen(false);
//         setData([]);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       setOpen(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   useEffect(() => {
//     if (runningArray?.content && runningArray?.content.length > 0) {
//       setData(runningArray?.content);
//       setData1(runningArray);
//     } else {
//       setData([]);
//     }
//     // setTotalPage(runningArray?.totalPages);
//     // settotalPageCount(runningArray?.pageable?.pageNumber);
//   }, [runningArray]);
//   // ..............................................................................//
//   async function PauseGet(cell) {
//     // setTableLoader(true);
//     setOpen(true);

//     try {
//       const result = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${pauseButton?.queue_code}&actionId=3`
//       );

//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         dispatch(runningState(result.data));
//         // dispatch(actionid("3"));

//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "Success",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       setOpen(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   // ............................................................................//
//   async function StoppedGet(cell) {
//     // setTableLoader(true);
//     setOpen(true);
//     try {
//       const result = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${stopButton?.queue_code}&actionId=5`
//       );

//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         dispatch(runningState(result.data));
//         dispatch(actionid("5"));

//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "Success",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       setOpen(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   // ..........................................................................//

//   async function ResumeGet(cell) {
//     // setTableLoader(true);
//     // alert("23333")
//     setOpen(true);
//     try {
//       const result = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${resumeButton?.queue_code}&actionId=4`
//       );

//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         // await dispatch(pauseState(result.data));
//         await dispatch(resumeState(result.data));
//         await dispatch(actionid("-1"));

//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "Success",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       setOpen(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   const columns = useMemo(
//     () => [
//       {
//         Header: "Id",
//         accessor: "id",
//         Cell: (cell) => {
//           // console.log("cell--", cell.row.index);
//           return (
//             <>
//               {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
//             </>
//           );
//         },
//       },
//       {
//         Header: "Campaign Name",

//         accessor: "event_Name",
//         Cell: (cell) => {
//           return (
//             <>
//               <div>{cell?.row?.original?.event_Name}</div>
//               <div className="my-2 fw-bold" style={{ color: "#959595" }}>
//                 {`(${cell?.row?.original?.username})`}
//               </div>
//             </>
//           );
//         },
//       },
     
//       {
//         Header: "Start Date Time",

//         accessor: "datetime_Scheduled", // accessor is the "key" in the data
//         // Cell: (cell) => {
//         //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
//         // },
//         Cell: (cell) => {
//           return (
//             <>
//               <div>
//                 {cell?.row?.original?.datetime_Scheduled
//                   ?.split(" ")
//                   ?.map((dataaa) => {
//                     return (
//                       <>
//                         <span>{dataaa}</span>
//                         <br />
//                       </>
//                     );
//                   })}
//               </div>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Exp Date Time",

//         accessor: "expected_Datetime", // accessor is the "key" in the data
//         Cell: (cell) => {
//           return (
//             <>
//               <div>
//                 {cell?.row?.original?.expected_Datetime
//                   ?.split(" ")
//                   ?.map((dataaa) => {
//                     return (
//                       <>
//                         <span>{dataaa}</span>
//                         <br />
//                       </>
//                     );
//                   })}
//               </div>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Sender Id",

//         accessor: "sender_Id", // accessor is the "key" in the data
//       },
//       {
//         Header: "Total sms",

//         accessor: "sms_Count", // accessor is the "key" in the data
//         Cell: (cell) => {
//           return <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>;
//         },
//       },

//       {
//         Header: "Sent",

//         accessor: "proccesed", // accessor is the "key" in the data
//         Cell: (cell) => {
//           return <>{cell.row.original.proccesed?.toLocaleString("en-US")}</>;
//         },
//       },
//       {
//         Header: "Delivered",

//         accessor: "deliverd", // accessor is the "key" in the data
//         Cell: (cell) => {
//           return <>{cell.row.original.deliverd?.toLocaleString("en-US")}</>;
//         },
//       },
//       {
//         Header: "Camp Type",

//         accessor: "campaign_Type", // accessor is the "key" in the data
//       },
//       {
//         Header: "Message",
//         accessor: "message", // accessor is the "key" in the data
//         Cell: (cell) => {
//           return (
//             <>
//               {cell.row.original.message.length >= 60 ? (
//                 <div className="">
//                   <div className="showMoreTd">
//                     {cell.row.original?.[`Show`]
//                       ? cell.row.original.message?.slice(0, 60) + "..."
//                       : cell.row.original.message}
//                   </div>
//                   <button
//                     className="showMore"
//                     onClick={() => {
//                       // Showdata?.[`Show${cell.row.index}`];

//                       const dataaa = [...data];

//                       dataaa[cell.row.index][`Show`] =
//                         !cell.row.original?.[`Show`];

//                       setData(dataaa);
//                     }}
//                   >
//                     {cell.row.original?.[`Show`] ? "More" : "Less"}
//                   </button>
//                 </div>
//               ) : (
//                 <div className="showMoreTd">{cell.row.original.message}</div>
//               )}
//             </>
//           );
//         },
//       },
//       {
//         Header: "Status",

//         accessor: "status",
//         Cell: (cell) => {
//           return (
//             <>
           

//               {cell.row.original.scheduled_Status == -1 ? (
//                 <div className="badge badge_8 bg-success ">Running</div>
//               ) : cell.row.original.scheduled_Status == 4 ? (
//                 <div className="badge badge_8 bg-secondary">Resume</div>
//               ) : cell.row.original.scheduled_Status == 3 ? (
//                 <div className="badge badge_8 bg-warning">Pause</div>
//               ) : (
//                 <div className="badge badge_8 bg-warning">In Process</div>
//               )}
//             </>
//           );
//         },
//       },

//       {
//         Header: "Action",
//         Footer: "User-Action",
//         accessor: "action",
//         Cell: (cell) => (
//           <div className="dropdown" style={{whiteSpace:'nowrap',}}>
//             {cell.row.original.scheduled_Status === -1 && (
//               <>
//                 <button
//                   className="btn color_1 p-0"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     pauseModal(cell);
//                   }}
//                 >
//                   <PauseCircleIcon className="text-warning" />
//                 </button>

//                 <button
//                   className="btn color_1 p-0 px-1"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     stopModal(cell);
//                   }}
//                 >
//                   <StopCircleIcon className="text-danger" />
//                 </button>
//               </>
//             )}
//             {cell.row.original.scheduled_Status === 3 && (
//               <>
//                 <button
//                   className="btn color_1 p-0"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     resumeModal(cell);
//                   }}
//                 >
//                   <NotStartedIcon />
//                 </button>

//                 <button
//                   className="btn color_1 px-1"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     stopModal(cell);
//                   }}
//                 >
//                   <StopCircleIcon
//                     className="text-danger"
//                     // className="text-warning"
//                   />
//                 </button>
//               </>
//             )}
//             {cell.row.original.scheduled_Status === 4 && (
//               <>
//                 <button
//                   className="btn color_1 px-1"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     pauseModal(cell);
//                   }}
//                 >
//                   <PauseCircleIcon className="text-warning" />
//                 </button>

//                 <button
//                   className="btn color_1 px-1"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   onClick={() => {
//                     stopModal(cell);
//                   }}
//                 >
//                   <StopCircleIcon className="text-danger" />
//                 </button>
//               </>
//             )}
//           </div>
//         ),

//         disableFilters: true,
//       },
//     ],
//     [data, TableStatus]
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     // footerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     selectedFlatRows,
//     setColumnOrder,
//     allColumns,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//       defaultColumn,
//       // initialState: { pageIndex: 1 }
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//     // useColumnOrder,
//     // useBlockLayout,
//     // useSticky,
//     // (hooks) => {
//     //   hooks.visibleColumns.push((columns) => {
//     //     return [
//     //       {
//     //         id: "selection",
//     //         Header: ({ getToggleAllRowsSelectedProps }) => (
//     //           <CheckBox {...getToggleAllRowsSelectedProps()} />
//     //         ),
//     //         Cell: ({ row }) => (
//     //           <CheckBox {...row.getToggleRowSelectedProps()} />
//     //         ),
//     //       },
//     //       ...columns,
//     //     ];
//     //   });
//     // }
//   );

//   const { globalFilter, pageIndex, pageSize } = state;

//   const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

//   const onChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 1000);

//   const deletUser = () => {
//     // console.log({ selectedFlatRows });
//   };

//   const changeOrder = () => {
//     setColumnOrder(["id", "username", "action", "role", "email"]);
//   };
//   useEffect(() => {
//     setrunningStateFun(ruuningFun);
//   }, [ruuningFun]);
//   useEffect(() => {
//     if (runningStateFun == false) {
//       RunningPost();
//     }
//   }, [TableStatus.pageSize, TableStatus.pageNo]);
//   // ..........................................ScrollBar Useefffect.......................
//   useEffect(() => {
//     if (wrapper1Ref.current && wrapper2Ref.current) {
//       wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
//       wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
//     }
//     updateDivWidths();
//     window.addEventListener("resize", updateDivWidths);
//     return () => {
//       window.removeEventListener("resize", updateDivWidths);
//     };
//   }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

//   // ............................................End.........................//
//   return (
//     <div>
//       <div>
//         <Backdrop
//           sx={{
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//         >
//           <Loader />
//         </Backdrop>
//       </div>

//       {/* {resumeButton != undefined && ( */}
//       <div>
//         <button
//           ref={resumebuttonModal}
//           type="button"
//           className="btn btn-primary d-none"
//           data-bs-toggle="modal"
//           data-bs-target="#staticBackdrop1"
//         >
//           Launch static backdrop modal
//         </button>

//         <div
//           className="modal fade"
//           id="staticBackdrop1"
//           data-bs-backdrop="static"
//           data-bs-keyboard="false"
//           tabindex="-1"
//           aria-labelledby="staticBackdrop1Label"
//           aria-hidden="true"
//         >
//           <div
//             className="modal-dialog "
//             style={{ width: "30%", maxWidth: "100%" }}
//           >
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="staticBackdrop1Label">
//                   Are you sure you want to resume this?
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="modal-footer justify-content-between border-0">
//                   <button
//                     type="button"
//                     className="btn btn-secondary shadow"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary editcolor shadow okbtn px-3"
//                     data-bs-dismiss="modal"
//                     onClick={ResumeGet}
//                   >
//                     Resume
//                   </button>
//                 </div>
//               </div>
//               {/* <div class="modal-footer"> */}

//               {/* </div> */}
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* )} */}
//       {/* {pauseButton != undefined && ( */}
//       <div>
//         <button
//           ref={pausebuttonModal}
//           type="button"
//           className="btn btn-primary d-none"
//           data-bs-toggle="modal"
//           data-bs-target="#staticBackdrop2"
//         >
//           Launch static backdrop modal
//         </button>

//         <div
//           className="modal fade"
//           id="staticBackdrop2"
//           data-bs-backdrop="static"
//           data-bs-keyboard="false"
//           tabindex="-1"
//           aria-labelledby="staticBackdrop2Label"
//           aria-hidden="true"
//         >
//           <div
//             className="modal-dialog"
//             style={{ width: "28%", maxWidth: "100%" }}
//           >
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="staticBackdrop2Label">
//                   Are you sure you want to pause this?
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="modal-footer justify-content-between border-0">
//                   <button
//                     type="button"
//                     className="btn btn-secondary shadow"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary editcolor shadow okbtn px-3"
//                     data-bs-dismiss="modal"
//                     onClick={PauseGet}
//                   >
//                     Pause
//                   </button>
//                 </div>
//               </div>
//               {/* <div class="modal-footer"> */}

//               {/* </div> */}
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* )} */}
//       {/* {stopButton != undefined && ( */}
//       <div>
//         <button
//           ref={stopbuttonModal}
//           type="button"
//           className="btn btn-primary d-none"
//           data-bs-toggle="modal"
//           data-bs-target="#staticBackdrop3"
//         >
//           Launch static backdrop modal
//         </button>
//         <div
//           className="modal fade"
//           id="staticBackdrop3"
//           data-bs-backdrop="static"
//           data-bs-keyboard="false"
//           tabindex="-1"
//           aria-labelledby="staticBackdrop3Label"
//           aria-hidden="true"
//         >
//           <div
//             className="modal-dialog"
//             style={{ width: "27%", maxWidth: "100%" }}
//           >
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="staticBackdrop3Label">
//                   Are you sure you want to stop this?
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="modal-footer justify-content-between border-0">
//                   <button
//                     type="button"
//                     className="btn btn-secondary shadow"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary editcolor shadow okbtn px-4"
//                     data-bs-dismiss="modal"
//                     onClick={StoppedGet}
//                   >
//                     Stop
//                   </button>
//                 </div>
//               </div>
//               {/* <div class="modal-footer"> */}

//               {/* </div> */}
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* )} */}
//       {data?.length > 0 ? (
//         <>
//           <div className="card-body">
//             <div className="card shadow-none border bg_blue mt-4">
//               <span className="badge rounded-pill bg-primary mt-n3 ms-5">
//                 {/* Add Number */}
//                 Running
//               </span>

//               {hideSkeleton == true ? (
//                 <>
//                   <Box sx={{ width: "100%" }}>
//                     <Skeleton />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     <Skeleton animation="wave" />
//                     {/* <Skeleton animation={false} /> */}
//                   </Box>
//                 </>
//               ) : (
//                 <>
//                   <div class="card-body ">
//                     <div className="d-flex justify-content-between mb-3">
//                       <select
//                         value={TableStatus.pageSize}
//                         className="dropdown"
//                         onChange={(e) => {
//                           setPageSize(Number(e.target.value));
//                           setTableStatus({
//                             ...TableStatus,
//                             pageSize: e.target.value,
//                             pageNo: 0,
//                           });
//                         }}
//                       >
//                         {[10, 25, 50].map((value, i) => {
//                           return (
//                             <option
//                               className="dropdown-menu"
//                               aria-labelledby="dropdownMenuButton1"
//                               value={value}
//                               key={value}
//                             >
//                               Show {value}
//                             </option>
//                           );
//                         })}
//                       </select>
//                       <Tooltip title="Refresh">
//                         <button
//                           type="submit"
//                           className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
//                           // onClick={RefreshBtn}
//                           onClick={() => RefreshBtn("Text to Copy")}
//                         >
//                           {/* <i class="material-icons opacity-10">refresh</i> */}
//                           <RefreshIcon />
//                         </button>
//                       </Tooltip>
//                     </div>

//                     <div>
//                       {selectedFlatRows.length > 0 && (
//                         <button onClick={deletUser}>Delete Users</button>
//                       )}
//                     </div>



//                     <div className="table-responsive">
//                       <table
//                         {...getTableProps()}
//                         id="example"
//                         className="table table-striped message_table table-bordered dataTable table-sm"
//                         style={{ width: "100%" }}
//                       >
//                         <thead>
//                           {headerGroups.map((headerGroup) => (
//                             <tr {...headerGroup.getHeaderGroupProps()}>
//                               {headerGroup.headers.map((column) => (
//                                 <th
//                                   {...column.getHeaderProps(
//                                     column.getSortByToggleProps()
//                                   )}
//                                   className={
//                                     column?.Header == "Message"
//                                       ? "text-center width_2 update_th messageWidth"
//                                       : column?.Header == "Camp Type"
//                                       ? "text-center width_2 update_th_sp d-flex border-start-0"
//                                       : "text-center width_2 update_th_sp "
//                                   }
//                                 >
//                                   {column.render("Header")}
//                                   <span>
//                                     {column.isSorted
//                                       ? column.isSortedDesc
//                                         ? "↑"
//                                         : "↓"
//                                       : ""}
//                                   </span>
//                                   {column.Header == "Camp Type" ? (
//                                     <>
//                                       <InputAdornment
//                                         position="end"
//                                         className="my-auto"
//                                       >
//                                         <Tooltip
//                                           title={"P-Promotional T-Transactional"
//                                             .split(" ")
//                                             .map((arg) => {
//                                               return (
//                                                 <>
//                                                   {arg}
//                                                   <br />
//                                                 </>
//                                               );
//                                             })}
//                                           id="toolTipId"
//                                           placement="top"
//                                           arrow
//                                           sx={{ color: "white" }}
//                                         >
//                                           <InfoIcon />
//                                         </Tooltip>
//                                       </InputAdornment>
//                                     </>
//                                   ) : (
//                                     <></>
//                                   )}
//                                   {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
//                                 </th>
//                               ))}
//                             </tr>
//                           ))}
//                         </thead>
//                         <tbody class='onhover_change' {...getTableBodyProps()} id="svg_tbody">
//                           {page.map((row) => {
//                             prepareRow(row);
//                             return (
//                               <tr
//                                 {...row.getRowProps()}
//                               >
//                                 {row.cells.map((cell) => {
//                                   return (
//                                     <td
//                                       {...cell.getCellProps()}
//                                       // className="text-start"
//                                       className={
//                                         cell.column.Header ==
//                                           "SMS sent count" ||
//                                         cell.column.Header == "Sender Id" ||
//                                         cell.column.Header == "Total sms" ||
//                                         cell.column.Header == "Sent" ||
//                                         cell.column.Header == "Deliverd" ||
//                                         cell.column.Header == "Pending"
//                                           ? "text-end update_td"
//                                           : cell.column.Header == "Action" ||
//                                             cell.column.Header == "Camp Type" ||
//                                             cell.column.Header == "Unicode" ||
//                                             cell.column.Header == "Status"
//                                           ? "text-center update_td"
//                                           : "text-start update_td"
//                                       }
//                                     >
//                                       {cell.render("Cell")}
//                                     </td>
//                                   );
//                                 })}
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>

//                     <div className="d-flex justify-content-between mt-3">
//                       <div>
//                         <span>
//                           Page:
//                           <strong>
//                             {data1?.pageable?.pageNumber + 1} of {""}
//                             {data1?.totalPages}
//                           </strong>
//                         </span>
//                       </div>




//                       <div className="prev_next d-flex align-items-center">
//                 <button
//                       className=" css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
//                       type="button"
//                       // style={{ background: "#2C97D4" }}
//                       //  disabled={data1?.pageable?.pageNumber == 0}
//                       onClick={() => {
                       
//                         setTableStatus({
//                           ...TableStatus,
//                           pageNo:0,
//                         });
//                         setPaginationPage(1)
//                       }}
//                     >
//                       First
//                     </button>

//                 <Stack spacing={2}>
//               <Pagination
//                 onChange={(event, value) => {
//                   console.log("va--", value);
//                   setTableStatus({
//                     ...TableStatus,
//                     pageNo: Number(value) - 1,
//                   });
//                   setPaginationPage(value);
//                   setrunningStateFun(false);
//                 }}
//                 page={paginationPage}
//                 count={data1 ? data1?.totalPages : ""}
               
//                 variant="outlined"
//                 shape="rounded"
                
//             color="primary"
//               />
//             </Stack>
//             <button
//                       className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
//                       type="button"
//                       // style={{ background: "#2C97D4" }}
//                       // disabled={
//                       //   data1?.totalPages == data1?.pageable?.pageNumber + 1
//                       //  }
//                       onClick={() => {
//                         // alert("gg")
//                         setTableStatus({
//                           ...TableStatus,
//                           pageNo:data1?.totalPages -1 ,
//                         });
//                         setPaginationPage(data1?.totalPages)

//                       }}
//                     >
//                       Last
//                     </button>
                
//               </div>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </>
//       ) : (
//         <>
        
//           <div className="text-center mt-4">
//             {data?.length == 0 && open1 ? null : (
//               <div className="text-center">
//                 <h5>No Record Found..!!</h5>
//               </div>
//             )}
//           </div>

//         </>
//       )}
//     </div>
//   );
// }
















import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { TextField, Tooltip, InputAdornment } from "@mui/material";
import { common_axios } from "../../../../App";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../../../../components/Loader";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import Swal from "sweetalert2";

import {
  actionid,
  runningState,
  pauseState,
  resumeState,
  refreshrunning,
  schedulelist,
  runninglist,
  stoppedlist,
  mainSkelton,
} from "../../../../redux/features/pageSlices";
import { useDispatch } from "react-redux";
import NotStartedIcon from "@mui/icons-material/NotStarted";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { processlist } from "../../../../redux/features/pageSlices";
import InfoIcon from "@mui/icons-material/Info";
import * as React from "react";
import Pagination from "@mui/material/Pagination";
import Fab from "@mui/material/Fab";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import {
  Stack,
} from "@mui/material";
export default function RunningAdmin({ runningArray, open: open1 }) {
  // .....................................................Scroll Bar.................................................................//
  const wrapper1Ref = useRef(null);
  const wrapper2Ref = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);

  const handleWrapper1Scroll = (e) => {
    wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
  };

  const handleWrapper2Scroll = (e) => {
    wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
  };

  const updateDivWidths = () => {
    // if (div1Ref.current && div2Ref.current) {
    //   div1Ref.current.style.width =
    //     div2Ref.current.querySelector("table").offsetWidth + "px";
    //   div2Ref.current.style.width =
    //     div2Ref.current.querySelector("table").offsetWidth + "px";
    // }
  };

  // ..................................................End Of Scroll Bar..............................................................//

  const dispatch = useDispatch();
  const [open, setOpen] = useState();
  const [scheduledata, setScheduleData] = useState([]);
  const [ruuningFun, setRunningFun] = useState(true);
  const [runningStateFun, setrunningStateFun] = useState();
  const [ScheduleTotalCount, setScheduleTotalCount] = useState();
  const [data, setData] = useState([]);
  const [resumeButton, setResumeButton] = useState(undefined);
  const [pauseButton, setpauseButton] = useState(undefined);
  const [hideSkeleton, sethideSkeleton] = useState();
  const [data1, setData1] = useState([]);
  const [paginationPage, setPaginationPage] = React.useState(1);
  const [TableStatus, setTableStatus] = useState({
    pageNo: 0,
    pageSize: 10,
  });
  const [stopButton, setStopButton] = useState(undefined);
  const resumebuttonModal = useRef(null);

  const resumeModal = async (cell) => {
    await setResumeButton(cell.row.original);
    await resumebuttonModal.current.click();
  };
  const pausebuttonModal = useRef(null);

  const pauseModal = async (cell) => {
    await setpauseButton(cell.row.original);
    await pausebuttonModal.current.click();
  };
  const stopbuttonModal = useRef(null);

  const stopModal = async (cell) => {
    await setStopButton(cell.row.original);
    await stopbuttonModal.current.click();
  };
  const customId1 = "custom-id-yess";

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  // ...........................Rfresh API....................//
  async function RefreshBtn(values) {
    // setTableLoader(true);

    sethideSkeleton(true);
    dispatch(mainSkelton(true));
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        sethideSkeleton(false);
        // setData(result.data.runningList.content);
        // await setTotalPage(result.data.scheduledList.totalPages);
        // await settotalPageCount(result.data.scheduledList.pageable.pageNumber);
        // await setScheduleTotalCount(result.data.scheduledList.totalElements);
        await setData1(result.data?.running);
        for (
          let index = 0;
          index < result.data.running?.length;
          index++
        ) {
          result.data.running[index][`Show`] = true;
          // arr.push(obj);
        }
        // dispatch(refreshrunning(result.data));
        dispatch(mainSkelton(false));
        dispatch(schedulelist(result?.data?.scheduled));
        dispatch(runninglist(result?.data?.running));
        dispatch(stoppedlist(result?.data.stopped));
        dispatch(processlist(result?.data?.createdCampaign));

        // dispatch(processlist(result?.data.process));
        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else if (result.data?.statusDescription?.statusCode == 220) {
        // alert("here");
        dispatch(mainSkelton(false));
        setScheduleTotalCount(null);
        dispatch(schedulelist([]));
        dispatch(runninglist([]));
        dispatch(stoppedlist([]));
        dispatch(processlist([]));
       
      }  else if (result.data.statusDescription.statusCode == 202) {
        sethideSkeleton(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        sethideSkeleton(false);
        dispatch(mainSkelton(false));
        // toast.error(result.data.statusDescription.statusMessage,{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      sethideSkeleton(false);
      dispatch(mainSkelton(false));

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  // ...........................Status API....................//
  async function RunningPost(values) {
    // setTableLoader(true);

    setOpen(true);
    setData([]);
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
   

        for (
          let index = 0;
          index < result.data.running?.content?.length;
          index++
        ) {
          result.data.running.content[index][`Show`] = true;
          // arr.push(obj);
        }
        setOpen(false);
        await setData1(result.data?.running);

        setData(result.data.running.content);
        // await setData1(result.data?.running);

        // await setTotalPage(result.data.runningList.totalPages);
        // await settotalPageCount(result.data.runningList.pageable.pageNumber);
        await setScheduleTotalCount(result.data.running.totalElements);
        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else {
        setOpen(false);
        setData([]);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  useEffect(() => {
    if (runningArray?.content && runningArray?.content.length > 0) {
      setData(runningArray?.content);
      setData1(runningArray);
    } else {
      setData([]);
    }
    // setTotalPage(runningArray?.totalPages);
    // settotalPageCount(runningArray?.pageable?.pageNumber);
  }, [runningArray]);
  // ..............................................................................//
  async function PauseGet(cell) {
    // setTableLoader(true);
    setOpen(true);

    try {
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${pauseButton?.queue_code}&actionId=3`
      );

      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        dispatch(runningState(result.data));
        // dispatch(actionid("3"));

        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Success",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // ............................................................................//
  async function StoppedGet(cell) {
    // setTableLoader(true);
    setOpen(true);
    try {
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${stopButton?.queue_code}&actionId=5`
      );

      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        dispatch(runningState(result.data));
        dispatch(actionid("5"));

        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Success",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // ..........................................................................//

  async function ResumeGet(cell) {
    // setTableLoader(true);
    // alert("23333")
    setOpen(true);
    try {
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/action?queueCode=${resumeButton?.queue_code}&actionId=4`
      );

      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // await dispatch(pauseState(result.data));
        await dispatch(resumeState(result.data));
        await dispatch(actionid("-1"));

        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Success",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => {
          // console.log("cell--", cell.row.index);
          return (
            <>
              {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
            </>
          );
        },
      },
      {
        Header: "Campaign Name",

        accessor: "event_Name",
        Cell: (cell) => {
          return (
            <>
              <div>{cell?.row?.original?.event_Name}</div>
              <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                {`(${cell?.row?.original?.username})`}
              </div>
            </>
          );
        },
      },
     
      {
        Header: "Start Date Time",

        accessor: "datetime_Scheduled", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
        // },
        Cell: (cell) => {
          return (
            <>
              <div>
                {cell?.row?.original?.datetime_Scheduled
                  ?.split(" ")
                  ?.map((dataaa) => {
                    return (
                      <>
                        <span>{dataaa}</span>
                        <br />
                      </>
                    );
                  })}
              </div>
            </>
          );
        },
      },
      {
        Header: "Exp Date Time",

        accessor: "expected_Datetime", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              <div>
                {cell?.row?.original?.expected_Datetime
                  ?.split(" ")
                  ?.map((dataaa) => {
                    return (
                      <>
                        <span>{dataaa}</span>
                        <br />
                      </>
                    );
                  })}
              </div>
            </>
          );
        },
      },
      {
        Header: "Sender Id",

        accessor: "sender_Id", // accessor is the "key" in the data
      },
      {
        Header: "Total sms",

        accessor: "sms_Count", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>;
        },
      },

      {
        Header: "Sent",

        accessor: "proccesed", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{cell.row.original.proccesed?.toLocaleString("en-US")}</>;
        },
      },
      {
        Header: "Delivered",

        accessor: "deliverd", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{cell.row.original.deliverd?.toLocaleString("en-US")}</>;
        },
      },
      {
        Header: "Camp Type",

        accessor: "campaign_Type", // accessor is the "key" in the data
      },
      {
        Header: "Message",
        accessor: "message", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.message.length >= 60 ? (
                <div className="">
                  <div className="showMoreTd">
                     {cell.row.original?.[`Show`] == true
                     ? cell.row.original.message?.slice(0, 60) + "..."
                      : cell.row.original.message}
                  </div>
                  <button
                    className="showMore"
                    onClick={() => {
                      // Showdata?.[`Show${cell.row.index}`];

                      const dataaa = [...data];

                      dataaa[cell.row.index][`Show`] =
                        !cell.row.original?.[`Show`];

                      setData(dataaa);
                    }}
                  >
                   {cell.row.original?.[`Show`]== true ? "More" : "Less"}
                  </button>
                </div>
              ) : (
                <div className="showMoreTd">{cell.row.original.message}</div>
              )}
            </>
          );
        },
      },
      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
           

              {cell.row.original.scheduled_Status == -1 ? (
                <div className="badge badge_8 bg-success ">Running</div>
              ) : cell.row.original.scheduled_Status == 4 ? (
                <div className="badge badge_8 bg-secondary">Resume</div>
              ) : cell.row.original.scheduled_Status == 3 ? (
                <div className="badge badge_8 bg-warning">Pause</div>
              ) : (
                <div className="badge badge_8 bg-warning">In Process</div>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        Footer: "User-Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown" style={{whiteSpace:'nowrap',}}>
            {cell.row.original.scheduled_Status === -1 && (
              <>
                <button
                  className="btn color_1 p-0"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    pauseModal(cell);
                  }}
                >
                  <PauseCircleIcon className="text-warning" />
                </button>

                <button
                  className="btn color_1 p-0 px-1"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    stopModal(cell);
                  }}
                >
                  <StopCircleIcon className="text-danger" />
                </button>
              </>
            )}
            {cell.row.original.scheduled_Status === 3 && (
              <>
                <button
                  className="btn color_1 p-0"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    resumeModal(cell);
                  }}
                >
                  <NotStartedIcon />
                </button>

                <button
                  className="btn color_1 px-1"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    stopModal(cell);
                  }}
                >
                  <StopCircleIcon
                    className="text-danger"
                    // className="text-warning"
                  />
                </button>
              </>
            )}
            {cell.row.original.scheduled_Status === 4 && (
              <>
                <button
                  className="btn color_1 px-1"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    pauseModal(cell);
                  }}
                >
                  <PauseCircleIcon className="text-warning" />
                </button>

                <button
                  className="btn color_1 px-1"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    stopModal(cell);
                  }}
                >
                  <StopCircleIcon className="text-danger" />
                </button>
              </>
            )}
          </div>
        ),

        disableFilters: true,
      },
    ],
    [data, TableStatus]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  useEffect(() => {
    setrunningStateFun(ruuningFun);
  }, [ruuningFun]);
  useEffect(() => {
    if (runningStateFun == false) {
      RunningPost();
    }
  }, [TableStatus.pageSize, TableStatus.pageNo]);
  // ..........................................ScrollBar Useefffect.......................
  useEffect(() => {
    if (wrapper1Ref.current && wrapper2Ref.current) {
      wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
      wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
    }
    updateDivWidths();
    window.addEventListener("resize", updateDivWidths);
    return () => {
      window.removeEventListener("resize", updateDivWidths);
    };
  }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

  // ............................................End.........................//




  const [showFab, setShowFab] = useState(true);
  const [showFabLeft, setShowFabLeft] = useState(true);
  console.log("kks",showFab)
  const handleScrollRight = () => {
    const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
    if (table) {
      const nextScrollLeft = table.scrollLeft + 500; // Adjust the scroll amount as needed
      // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
      // setShowFab(false);
      // setShowFabLeft(true);
      table.scroll({
        left: nextScrollLeft,
        behavior: "smooth",
      });
    }
  };
  const handleScroll = () => {
    const table = document.getElementById("tableTarget");
    if (table) {
      if (
        Math.round(table.scrollLeft) <
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(true);
        // setShowFabLeft(false);
  
      } else if (
        Math.round(table.scrollLeft) ==
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false);
        // setShowFabLeft(true);
  
      }
    }
  };
  
  
  useEffect(()=>{
    handleScroll();
  },[])
  
  
  const handleScrollLeft = () => {
    const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
    if (table) {
      const nextScrollRight = table.scrollRight + 500; // Adjust the scroll amount as needed
      // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
      // setShowFabLeft(false);
      // setShowFab(true)
      table.scroll({
        left: nextScrollRight,
        behavior: "smooth",
      });
    }
  };
  
  const handleScroll1 = () => {
    const table = document.getElementById("tableTarget");
    if (table) {
      // console.log(
      //   "tablescroll",
      //   Math.round(table.scrollLeft),
      //   table.scrollWidth - table.clientWidth
      // );
      if (
        Math.round(table.scrollRight) <
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false)
        // setShowFabLeft(true);
      } else if (
        Math.round(table.scrollRight) ==
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false)
        // setShowFabLeft(false);
      }
    }
  };
  useEffect(()=>{
    handleScroll1();
  },[])
  










  return (
    <div>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>

      {/* {resumeButton != undefined && ( */}
      <div>
        <button
          ref={resumebuttonModal}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop1"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop1Label"
          aria-hidden="true"
        >
          <div
            className="modal-dialog "
            style={{ width: "30%", maxWidth: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop1Label">
                  Are you sure you want to resume this?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="modal-footer justify-content-between border-0">
                  <button
                    type="button"
                    className="btn btn-secondary shadow"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary editcolor shadow okbtn px-3"
                    data-bs-dismiss="modal"
                    onClick={ResumeGet}
                  >
                    Resume
                  </button>
                </div>
              </div>
              {/* <div class="modal-footer"> */}

              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
      {/* {pauseButton != undefined && ( */}
      <div>
        <button
          ref={pausebuttonModal}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop2"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop2"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop2Label"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            style={{ width: "28%", maxWidth: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop2Label">
                  Are you sure you want to pause this?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="modal-footer justify-content-between border-0">
                  <button
                    type="button"
                    className="btn btn-secondary shadow"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary editcolor shadow okbtn px-3"
                    data-bs-dismiss="modal"
                    onClick={PauseGet}
                  >
                    Pause
                  </button>
                </div>
              </div>
              {/* <div class="modal-footer"> */}

              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
      {/* {stopButton != undefined && ( */}
      <div>
        <button
          ref={stopbuttonModal}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop3"
        >
          Launch static backdrop modal
        </button>
        <div
          className="modal fade"
          id="staticBackdrop3"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop3Label"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            style={{ width: "27%", maxWidth: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop3Label">
                  Are you sure you want to stop this?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="modal-footer justify-content-between border-0">
                  <button
                    type="button"
                    className="btn btn-secondary shadow"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary editcolor shadow okbtn px-4"
                    data-bs-dismiss="modal"
                    onClick={StoppedGet}
                  >
                    Stop
                  </button>
                </div>
              </div>
              {/* <div class="modal-footer"> */}

              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
      {data?.length > 0 ? (
        <>
          <div className="card-body">
            <div className="card shadow-none border bg_blue mt-4">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                {/* Add Number */}
                Running
              </span>

              {hideSkeleton == true ? (
                <>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    {/* <Skeleton animation={false} /> */}
                  </Box>
                </>
              ) : (
                <>
                  <div class="card-body ">
                    <div className="d-flex justify-content-between mb-3">
                      <select
                        value={TableStatus.pageSize}
                        className="dropdown"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setTableStatus({
                            ...TableStatus,
                            pageSize: e.target.value,
                            pageNo: 0,
                          });
                          setrunningStateFun(false);
                          setPaginationPage(1)
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select>
                      <Tooltip title="Refresh">
                        <button
                          type="submit"
                          className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                          // onClick={RefreshBtn}
                          onClick={() => RefreshBtn("Text to Copy")}
                        >
                          {/* <i class="material-icons opacity-10">refresh</i> */}
                          <RefreshIcon />
                        </button>
                      </Tooltip>
                    </div>

                    <div>
                      {selectedFlatRows.length > 0 && (
                        <button onClick={deletUser}>Delete Users</button>
                      )}
                    </div>


                    <div style={{position: "sticky",
    top: "0px",
    zIndex: "9"}}>
 <div class="d-flex justify-content-between" >
                    <div >
                        {showFabLeft && (
                    <Fab
                      // className="fab position-sticky"
                      onClick={handleScrollLeft}
                      // color="primary"
                      style={{
                        backgroundColor: "rgb(89 144 175)",
                        color: "white",
                        width:'31px',
                        height:'31px',
position:'sticky',
top:'0',
right:'0',
                        // marginTop: "46px"
                        
                      }}
                      // aria-label="add"
                    >
                      <ArrowLeftIcon style={{fontSize: "23px"}} />
                    </Fab>
                  )}
               </div>   
             <div>
                        {showFab && (
                    <Fab
                      // className="fab position-sticky"
                      onClick={handleScrollRight}
                      // color="primary"
                      style={{
                        backgroundColor: "rgb(89 144 175)",
                        color: "white",
                        position:'sticky',
                        top:'0',
                        right:'0',
                        width:'31px',
                        height:'31px',
                      }}
                      // aria-label="add"
                    >

  <ArrowRightIcon style={{fontSize: "23px"}}/>
                      {/* <PlayArrowIcon /> */}
                    </Fab>
                  )}
 </div>
                    </div>

                    </div>
                    <div className="table-responsive mt-2" id="tableTarget" onScroll={(()=>{
 handleScroll();
handleScroll1()
                    })}>
                      <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped message_table table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  className={
                                    column?.Header == "Message"
                                      ? "text-center width_2 update_th messageWidth"
                                      : column?.Header == "Camp Type"
                                      ? "text-center width_2 update_th_sp d-flex border-start-0"
                                      : "text-center width_2 update_th_sp "
                                  }
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>
                                  {column.Header == "Camp Type" ? (
                                    <>
                                      <InputAdornment
                                        position="end"
                                        className="my-auto"
                                      >
                                        <Tooltip
                                          title={"P-Promotional T-Transactional"
                                            .split(" ")
                                            .map((arg) => {
                                              return (
                                                <>
                                                  {arg}
                                                  <br />
                                                </>
                                              );
                                            })}
                                          id="toolTipId"
                                          placement="top"
                                          arrow
                                          sx={{ color: "white" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody class='onhover_change' {...getTableBodyProps()} id="svg_tbody">
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr
                                {...row.getRowProps()}
                              >
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      // className="text-start"
                                      className={
                                        cell.column.Header ==
                                          "SMS sent count" ||
                                        cell.column.Header == "Sender Id" ||
                                        cell.column.Header == "Total sms" ||
                                        cell.column.Header == "Sent" ||
                                        cell.column.Header == "Deliverd" ||
                                        cell.column.Header == "Pending"
                                          ? "text-end update_td"
                                          : cell.column.Header == "Action" ||
                                            cell.column.Header == "Camp Type" ||
                                            cell.column.Header == "Unicode" ||
                                            cell.column.Header == "Status"
                                          ? "text-center update_td"
                                          : "text-start update_td"
                                      }
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div className="d-flex justify-content-between mt-3">
                      <div>
                        <span>
                          Page:
                          <strong>
                            {data1?.pageable?.pageNumber + 1} of {""}
                            {data1?.totalPages}
                          </strong>
                        </span>
                      </div>




                      <div className="prev_next d-flex align-items-center">
                <button
                      className=" css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                  setrunningStateFun(false);
                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                          ...TableStatus,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
        
          <div className="text-center mt-4">
            {data?.length == 0 && open1 ? null : (
              <div className="text-center">
                <h5>No Record Found..!!</h5>
              </div>
            )}
          </div>

        </>
      )}
    </div>
  );
}
